import { AppBar, Toolbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import * as Sentry from '@sentry/react'
import { useNavigate } from 'react-router'
import ChedarLogo from 'src/assets/images/ChedarMainLogo.png'
import ChooseCompanyForCompanyMultipleTenantAdminOrFreelancerButton from 'src/components/sections/Navbar/ChooseCompanyForCompanyMultipleTenantAdminOrFreelancerButton'
import HelpButton from 'src/components/sections/Navbar/HelpButton'
import LanguageButton from 'src/components/sections/Navbar/LanguageButton'
import SettingsButton from 'src/components/sections/Navbar/SettingsButton'
import MenuDrawer from 'src/components/ui/Drawer/MenuDrawer'
import SearchBar from 'src/components/ui/SearchBar/SearchBar'
import { useFetchUserInfoQuery } from 'src/redux/api/graphql/userInfoApi'
import { logOutUser } from 'src/redux/slices/auth'
import { useAppSelector, useAppThunkDispatch } from 'src/utils/hooks/reduxHooks'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	iconImage: {
		flexGrow: 1,
	},
	logoImage: {
		height: '2.6rem',
	},
}))

function Navbar() {
	const classes = useStyles()
	const dispatchThunk = useAppThunkDispatch()
	const navigate = useNavigate()
	const userLoginStatus = useAppSelector(
		(state) => state.auth.userLoginStatus
	)
	const userInfoId = useAppSelector((state) => state.auth.userInfo?.id)
	const { data: userInfo } = useFetchUserInfoQuery(
		{
			userInfoId: userInfoId!,
		},
		{
			skip: !userInfoId,
		}
	)
	const isFreelancer = userInfo?.cognitoGroup?.includes('freelancer')
	const isTeamAdmin =
		userInfo?.cognitoGroup?.includes('teamAdmin') ||
		userInfo?.cognitoGroup?.includes('subTeamAdmin')
	const isCompanyMultipleTenantAdmin = userInfo?.cognitoGroup?.includes(
		'companyMultipleTenantAdmin'
	)

	const handleLogout = () => {
		dispatchThunk(logOutUser())
		navigate('/', { replace: true })
		Sentry.setUser(null)
	}

	const navigateHome = () => {
		navigate('/')
	}

	return (
		<>
			<AppBar position="static">
				<Toolbar variant="dense">
					{userLoginStatus &&
						userInfo &&
						Object.keys(userInfo).length !== 0 && (
							<MenuDrawer
								userLoginStatus={userLoginStatus}
								isFreelancer={isFreelancer}
							/>
						)}
					<div className={classes.iconImage}>
						<img
							src={ChedarLogo}
							alt="Chedar Logo"
							className={classes.logoImage}
							onClick={navigateHome}
							onKeyUp={(e) => e.key === 'Enter' && navigateHome()}
						/>
					</div>
					{userLoginStatus &&
						userInfo &&
						Object.keys(userInfo).length !== 0 && <SearchBar />}
					{/* team and sub team admin don't have access to offline button */}
					{/* {!isTeamAdmin && <OfflineButton />} */}
					<LanguageButton />
					<HelpButton />
					{userLoginStatus &&
						userInfo &&
						Object.keys(userInfo).length !== 0 && (
							<SettingsButton
								handleLogout={handleLogout}
								isSmall={false}
							/>
						)}
					{(isCompanyMultipleTenantAdmin || isFreelancer) && (
						<ChooseCompanyForCompanyMultipleTenantAdminOrFreelancerButton />
					)}
				</Toolbar>
			</AppBar>
		</>
	)
}

export default Navbar
